// sets form as complete

const FormCompletionActions = {
  SET_FORM_COMPLETION: 'FormCompletion.SET_COMPLETED',
};

export default FormCompletionActions;
